import {ROUTES} from "../router/config";
import welcomeImage from "../assets/images/welcome.jpg";
import parentImage from "../assets/images/parent.jpg";
import addressImage from "../assets/images/address.jpg";
import studentImage from "../assets/images/student.jpg";
import confirmationImage from "../assets/images/confirmation.jpg";
import completeImage from "../assets/images/complete.jpg";

const ROUTE_IMAGES = {
    [ROUTES.PARENT]: parentImage,
    [ROUTES.ADDRESS]: addressImage,
    [ROUTES.STUDENTS]: studentImage,
    [ROUTES.CONFIRMATION]: confirmationImage,
    [ROUTES.COMPLETE]: completeImage,
    [ROUTES.WELCOME]: welcomeImage,
};

const ROUTE_STUDENTS = {
    [ROUTES.PARENT]: {class: 2028, name: "Gabby Boday"},
    [ROUTES.ADDRESS]: {class: 2030, name: "Bane Griffith"},
    [ROUTES.STUDENTS]: {class: 2027, name: "Hayley Naggar"},
    [ROUTES.CONFIRMATION]: {class: 2026, name: "Connor Bryce"},
    [ROUTES.COMPLETE]: {class: 2030, name: "Bane Griffith"},
    [ROUTES.WELCOME]: {class: 2028, name: "David Pyle"},
};

export const getImageForRoute = (pathname) => {
    const configKey = Object.keys(ROUTE_IMAGES).find((key) => pathname.includes(key));
    return ROUTE_IMAGES[configKey] || welcomeImage;
};

export const getStudentForRoute = (pathname) => {
    const configKey = Object.keys(ROUTE_STUDENTS).find((key) => pathname.includes(key));
    return ROUTE_STUDENTS[configKey] || ROUTE_STUDENTS[ROUTES.WELCOME];
};
